<template>
  <v-layout :class="sizeClass" :style="returnStyles" align-center justify-center>
    <span class="text-xs-center" :class="showH1 ? 'h1--small' : ''">
      <slot> </slot>
    </span>
  </v-layout>
</template>

<script>
export default {
  name: 'EmptyMessageBox',
  props: {
    sizeClass: {
      type: String,
      default: 'pl-empty-message-box',
    },
    height: {
      type: Number,
    },
    fontSize: {
      type: Number,
    },
    showH1: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    returnStyles() {
      const styles = {}

      if (this.height) styles.height = `${this.height}px`
      if (this.fontSize) styles.fontSize = `${this.fontSize}px`

      return styles
    },
  },
}
</script>
